import React, { useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  GENERATE_PROGRESS_TRAIL_HISTORY_LABEL,
  GENERATE_PROGRESS_TRAIL_LABEL,
} from '../GenerateExpression.constants';
import { modalSectionLabelStyles, progressTrailWrapperStyles } from '../GenerateExpression.styles';
import { GenerateExpressionTestIds } from '../GenerateExpression.testIds';

import { decorateEvents } from './ProgressTrail.utils';
import ProgressTrailRow from './ProgressTrailRow';

const ProgressTrail = ({ events, isLive = false }) => {
  const decorated = useMemo(() => decorateEvents(events), [events]);

  if (_.isEmpty(decorated)) {
    return null;
  }

  const label = isLive ? GENERATE_PROGRESS_TRAIL_LABEL : GENERATE_PROGRESS_TRAIL_HISTORY_LABEL;

  return (
    <Box data-testid={GenerateExpressionTestIds.MODAL_PROGRESS_TRAIL}>
      <Typography color="text.secondary" sx={modalSectionLabelStyles} variant="bold12">
        {label}
      </Typography>
      <Box sx={progressTrailWrapperStyles}>
        {decorated.map(event => (
          <ProgressTrailRow
            detail={event.detail}
            isSelfCorrect={event.isSelfCorrect}
            key={event.key}
            phase={event.phase}
          />
        ))}
      </Box>
    </Box>
  );
};

ProgressTrail.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      kind: PropTypes.string,
      phase: PropTypes.string,
      detail: PropTypes.string,
      turn: PropTypes.number,
      atUtc: PropTypes.string,
      candidateIndex: PropTypes.number,
    }),
  ),
  isLive: PropTypes.bool,
};

export default ProgressTrail;
